import { Box, Typography } from '@mui/material';
import type { SyberryTodayTaskGroup } from 'domain/people/syberryToday/types';

type SyberryTodayTaskGroupListProps = {
  groups: SyberryTodayTaskGroup[];
  activeGroupId: Nullable<string>;
  onSelectGroup: (groupId: string) => void;
};

const SyberryTodayTaskGroupList = ({ groups, activeGroupId, onSelectGroup }: SyberryTodayTaskGroupListProps) => (
  <Box sx={{ margin: '8px 0 16px' }} aria-label="Task groups">
    {groups.map(group => (
      <Box
        component="button"
        aria-label={`${group.name} group: ${group.totalCount} tasks, ${group.unreadCount} new`}
        aria-current={activeGroupId === group.id}
        key={group.id}
        type="button"
        onClick={() => onSelectGroup(group.id)}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
          marginBottom: 1.5,
          padding: 0,
          border: 0,
          background: 'transparent',
          color: 'textPrimary',
          textAlign: 'left',
          cursor: 'pointer',
          '&:hover': {
            color: 'secondary.main',
          },
          ...(activeGroupId === group.id && {
            fontWeight: 600,
          }),
        }}
      >
        <Typography variant="body1" component="span">
          {group.name}
        </Typography>
        <Box
          component="span"
          sx={{
            display: 'grid',
            gridTemplateColumns: '28px 24px',
            columnGap: 1,
            justifyContent: 'end',
            minWidth: '64px',
            textAlign: 'right',
          }}
        >
          <Typography component="span" variant="subtitle1" color={group.totalCount ? 'secondary' : 'textSecondary'}>
            {group.totalCount}
          </Typography>
          {group.unreadCount > 0 && (
            <Typography component="span" color="success" variant="subtitle1">
              {group.unreadCount}
            </Typography>
          )}
        </Box>
      </Box>
    ))}
  </Box>
);

export default SyberryTodayTaskGroupList;
